import _ from 'lodash'

export const generateOpdrachtSource = (counter, prefix) =>
  _.times(counter, item => ({
    value: `${prefix}${item}`,
    label: `${prefix}${item}`,
  }))
